import { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import useImageWrapper from "helpers/hooks/useImageWrapper";
import Photo from "components/shared/stays/Photo";
import styles from "components/stay/GalleryItem.module.scss";

function GalleryItem({ onClick, src }) {
  const { getImageWidth } = useImageWrapper();
  const [imgWidths, setImgWidths] = useState([0]);
  const imgWrapperRef = useRef();

  useEffect(() => {
    const calculatedWidth = getImageWidth([imgWrapperRef]);
    setImgWidths(calculatedWidth);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={styles.item}
      onClick={() => onClick()}
      onKeyPress={null}
      role="button"
      tabIndex="-1"
      ref={imgWrapperRef}
    >
      <Photo
        src={src}
        alt="Surf"
        layout="fill"
        objectFit="cover"
        placeholder
        containerWidth={imgWidths[0]}
      />
    </div>
  );
}

GalleryItem.propTypes = {
  onClick: PropTypes.func,
  src: PropTypes.string.isRequired,
};

export default GalleryItem;
